import { useQuery } from '@tanstack/react-query'
import { useCountriesStore } from '@/store'

export const useCountries = () => {
  const fetchCountries = useCountriesStore(state => state.fetchCountriesList)

  return useQuery({
    queryKey: ['countries'],
    queryFn: fetchCountries,
    staleTime: 1000 * 60 * 60, // 1 hour
    gcTime: 1000 * 60 * 60 * 24, // 24 hours
    refetchOnWindowFocus: false
  })
}
